import React from "react";
import PropTypes from "prop-types";
import HTML5Backend from "react-dnd-html5-backend";
import { DragDropContext } from "react-dnd";
import { connect } from "react-redux";
import update from "immutability-helper";
import _ from "lodash";

import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import RuleTableRowComponent from "./ruleTableRow.component";
import RuleHeaderSearchContainer from "./ruleHeaderSearch.container";
import RuleTableHeadersComponent from "./ruleTableHeader.component";
import NewColumnDialogComponent from "./newColumnDialog.component";

import { updateMetadataOrder } from "../../../store/actions/metadata.actions";
import {
  updateFileRulesApplied,
  updateFileSkippedColumnsHidden
} from "../../../store/actions/session.actions";
import RuleOptionsMenu from "./ruleOptionsMenu.component";

const tableHeaders = [
  "",
  "Source Value",
  "Target Value",
  "Counted Values",
  "Type",
  "Format",
  "Field Type",
  "Rule",
  "Applied Rules"
];

const styles = theme => ({
  tableWrapper: {
    width: "100%"
  },
  titleBlock: {
    width: "calc(100% - 350px)",
    padding: "25px 0 0 25px",
    float: "left"
  },
  searchBlock: {
    padding: "25px 0 0 0",
    textAlign: "right",
    marginLeft: "auto"
  },
  buttonBlock: {
    padding: "25px 0 0 0",
    width: "50px",

    textAlign: "right"
  },
  menuBlock: {
    padding: "25px 0 0 0"
  },
  table: {
    display: "table",
    fontFamily: theme.typography.fontFamily,
    width: "100%",
    borderCollapse: "unset",
    borderSpacing: 0
  },
  tableBody: {
    display: "table-row-group"
  },
  tableHolder: {
    height: "calc(100vh - 220px)",
    display: "block",
    overflow: "scroll",
  },

});

class RuleTableComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.renderTableBody = this.renderTableBody.bind(this);
    this.moveRule = this.moveRule.bind(this);
    this.dropRule = this.dropRule.bind(this);
    this.switchRulesApplied = this.switchRulesApplied.bind(this);
    this.switchSkippedColumnsHidden = this.switchSkippedColumnsHidden.bind(this);
    this.sortSkippedLinesToBottom = this.sortSkippedLinesToBottom.bind(this);
    this.state = {
      metadata: _.values(this.props.metadata).sort((a, b) => a.index - b.index).sort((a, b) => (a.type === 'Skip') - (b.type === 'Skip')),
      rulesApplied: this.props.currentFile.rulesApplied,
      skippedColumnsHidden: this.props.currentFile.skippedColumnsHidden,
      saving: false
    };
  }
  componentDidMount(){
    if (this.props.currentFile.rulesApplied === undefined) {
      this.setState({rulesApplied: true});
      this.props.updateFileRulesApplied(
        this.props.session.id,
        this.props.currentFile.id,
        true
      );
    }
    if (this.props.currentFile.skippedColumnsHidden === undefined) {
      this.setState({skippedColumnsHidden: true});
      this.props.updateFileSkippedColumnsHidden(
        this.props.session.id,
        this.props.currentFile.id,
        true);
    }
  }
  componentDidUpdate(prevProps) {

    if (prevProps.metadata !== this.props.metadata) {
      this.setState({ metadata: _.values(this.props.metadata).sort((a, b) => a.index - b.index),
    });
    }
  }

  handleSearchChange(newValue) {
    this.setState({
      metadata: _.values(newValue).sort((a, b) => a.index - b.index).sort((a, b) => (a.type === 'Skip') - (b.type === 'Skip')),
    });
  }
  sortSkippedLinesToBottom() {
    this.setState({
      metadata: _.values(this.state.metadata).sort((a, b) => a.index - b.index).sort((a, b) => (a.type === 'Skip') - (b.type === 'Skip')),
    });
  }

  async switchRulesApplied(checked) {
    this.setState({
      rulesApplied: checked,
    });
    this.props.updateFileRulesApplied(
      this.props.session.id,
      this.props.currentFile.id,
      checked
    );
  }
  async switchSkippedColumnsHidden(checked) {
    this.setState({
      skippedColumnsHidden: checked,
    });
    this.props.updateFileSkippedColumnsHidden(
      this.props.session.id,
      this.props.currentFile.id,
      checked
    );
  }
  moveRule(dragIndex, hoverIndex) {
    const { metadata } = this.state;
    const dragMetadata = metadata[dragIndex];
    this.setState(update(this.state, {
      metadata: {
        $splice: [[dragIndex, 1], [hoverIndex, 0, dragMetadata]],
      },
    }));
  }

  dropRule() {
    this.props.updateMetadataOrder(this.state.metadata);
  }

  renderTableBody() {
    const { rules, metadata, session } = this.props;

    return this.state.metadata.map((column, index) => (
      <RuleTableRowComponent
        key={column.key}
        index={index}
        metadata={metadata}
        column={column}
        rules={rules}
        session={session}
        rulesApplied={this.state.rulesApplied}
        skippedColumnsHidden={this.state.skippedColumnsHidden}
        moveRule={this.moveRule}
        dropRule={this.dropRule}
      />
    ));
  }

  render() {
    const {
      classes,
      currentFile,
      metadata,
      searchTerm,
    } = this.props;
    return (
      <React.Fragment>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            paddingRight: "25px"
          }}
        >
          <div className={classes.titleBlock}>
            <Typography variant="h4" gutterBottom>
              Columns
            </Typography>
          </div>
          <div className={classes.searchBlock}>
            <RuleHeaderSearchContainer
              metadata={metadata}
              applySearch={this.handleSearchChange}
              searchTerm={searchTerm}
            />
          </div>
          <div className={classes.buttonBlock}>
            <NewColumnDialogComponent
              isVirtualFile={currentFile.virtualFile}
              metadata={metadata}
            />
          </div>
          <div className={classes.menuBlock}>
            <RuleOptionsMenu
              rulesApplied={this.state.rulesApplied}
              skippedColumnsHidden={this.state.skippedColumnsHidden}
              updateFileSkippedColumnsHidden={this.switchSkippedColumnsHidden}
              updateFileRulesApplied={this.switchRulesApplied}
              handleSearchChange={this.handleSearchChange}
              sortSkippedLinesToBottom={this.sortSkippedLinesToBottom}
              saving={this.state.saving}
            />
          </div>
        </div>
        <div className={`${classes.tableHolder} print`}>
          <table className={classes.table}>
            <RuleTableHeadersComponent headers={tableHeaders} />
            <tbody className={classes.tableBody}>
              {this.renderTableBody()}
            </tbody>
          </table>
        </div>
        </React.Fragment>

    );
  }
}
RuleTableComponent.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  currentFile: PropTypes.shape({
    filename: PropTypes.string,
    virtualFile: PropTypes.bool,
    rulesApplied: PropTypes.bool,
    skippedColumnsHidden: PropTypes.bool,
    id: PropTypes.string
  }).isRequired,
  rules: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    attribute: PropTypes.string,
    index: PropTypes.number
  }).isRequired,
  metadata: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    format: PropTypes.string,
    mapped: PropTypes.bool,
    custom: PropTypes.bool,
    values: PropTypes.arrayOf(PropTypes.string),
    order: PropTypes.number
  }).isRequired,
  session: PropTypes.shape({
    id: PropTypes.string,
    files: PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      lastModified: PropTypes.number,
      virtualFile: PropTypes.bool,
      savedByUser: PropTypes.bool,
      rulesApplied: PropTypes.bool
    })
  }).isRequired,
  updateMetadataOrder: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired
  /* eslint-enable */
};

export default DragDropContext(HTML5Backend)(
  withStyles(styles)(
    connect(
      null,
      {
        updateMetadataOrder,
        updateFileRulesApplied,
        updateFileSkippedColumnsHidden
      }
    )(RuleTableComponent)
  )
);
